/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GradeEstimatorRequestDto } from '../models';
// @ts-ignore
import type { GradeEstimatorResponseDto } from '../models';
// @ts-ignore
import type { ImportPaygapPersonnelDto } from '../models';
// @ts-ignore
import type { PaygapMetricItemDto } from '../models';
// @ts-ignore
import type { PaygapPersonnelDto } from '../models';
// @ts-ignore
import type { PaygapSettingsDto } from '../models';
// @ts-ignore
import type { RunAnalysisRequestDto } from '../models';
// @ts-ignore
import type { RunAnalysisResponseDto } from '../models';
// @ts-ignore
import type { UniqueFieldValuesDto } from '../models';
// @ts-ignore
import type { UpdatePaygapSettingsDto } from '../models';
/**
 * PaygapApi - axios parameter creator
 * @export
 */
export const PaygapApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Proxies request to Azure Logic Apps grade estimator API. Returns suggested grades based on trait values and job/seniority points.
         * @summary Run grade estimation AI
         * @param {string} authorization 
         * @param {GradeEstimatorRequestDto} gradeEstimatorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paygapControllerEstimateGrades: async (authorization: string, gradeEstimatorRequestDto: GradeEstimatorRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('paygapControllerEstimateGrades', 'authorization', authorization)
            // verify required parameter 'gradeEstimatorRequestDto' is not null or undefined
            assertParamExists('paygapControllerEstimateGrades', 'gradeEstimatorRequestDto', gradeEstimatorRequestDto)
            const localVarPath = `/api/paygap/grade-estimator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gradeEstimatorRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get paygap metrics for current company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paygapControllerGetCurrentCompanyPaygapMetrics: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/paygap/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get personnel data for current company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paygapControllerGetCurrentCompanyPersonnel: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/paygap/personnel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get PayGap settings for current company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paygapControllerGetSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/paygap/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Extracts unique values for education, positions, and grading fields from personnel data. Used for auto-populating analysis parameters.
         * @summary Get unique field values from personnel data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paygapControllerGetUniqueFieldValues: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/paygap/personnel/unique-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import personnel data
         * @param {ImportPaygapPersonnelDto} importPaygapPersonnelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paygapControllerImportPersonnel: async (importPaygapPersonnelDto: ImportPaygapPersonnelDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importPaygapPersonnelDto' is not null or undefined
            assertParamExists('paygapControllerImportPersonnel', 'importPaygapPersonnelDto', importPaygapPersonnelDto)
            const localVarPath = `/api/paygap/personnel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importPaygapPersonnelDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Triggers PayGap analysis via Azure Logic Apps. This is a fire-and-forget operation - results will be stored in the database when the analysis completes.
         * @summary Run PayGap analysis
         * @param {string} authorization 
         * @param {RunAnalysisRequestDto} runAnalysisRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paygapControllerRunAnalysis: async (authorization: string, runAnalysisRequestDto: RunAnalysisRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('paygapControllerRunAnalysis', 'authorization', authorization)
            // verify required parameter 'runAnalysisRequestDto' is not null or undefined
            assertParamExists('paygapControllerRunAnalysis', 'runAnalysisRequestDto', runAnalysisRequestDto)
            const localVarPath = `/api/paygap/run-analysis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runAnalysisRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update PayGap settings for current company
         * @param {UpdatePaygapSettingsDto} updatePaygapSettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paygapControllerUpdateSettings: async (updatePaygapSettingsDto: UpdatePaygapSettingsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePaygapSettingsDto' is not null or undefined
            assertParamExists('paygapControllerUpdateSettings', 'updatePaygapSettingsDto', updatePaygapSettingsDto)
            const localVarPath = `/api/paygap/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePaygapSettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaygapApi - functional programming interface
 * @export
 */
export const PaygapApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaygapApiAxiosParamCreator(configuration)
    return {
        /**
         * Proxies request to Azure Logic Apps grade estimator API. Returns suggested grades based on trait values and job/seniority points.
         * @summary Run grade estimation AI
         * @param {string} authorization 
         * @param {GradeEstimatorRequestDto} gradeEstimatorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paygapControllerEstimateGrades(authorization: string, gradeEstimatorRequestDto: GradeEstimatorRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GradeEstimatorResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paygapControllerEstimateGrades(authorization, gradeEstimatorRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaygapApi.paygapControllerEstimateGrades']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get paygap metrics for current company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paygapControllerGetCurrentCompanyPaygapMetrics(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaygapMetricItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paygapControllerGetCurrentCompanyPaygapMetrics(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaygapApi.paygapControllerGetCurrentCompanyPaygapMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get personnel data for current company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paygapControllerGetCurrentCompanyPersonnel(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaygapPersonnelDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paygapControllerGetCurrentCompanyPersonnel(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaygapApi.paygapControllerGetCurrentCompanyPersonnel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get PayGap settings for current company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paygapControllerGetSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaygapSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paygapControllerGetSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaygapApi.paygapControllerGetSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Extracts unique values for education, positions, and grading fields from personnel data. Used for auto-populating analysis parameters.
         * @summary Get unique field values from personnel data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paygapControllerGetUniqueFieldValues(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UniqueFieldValuesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paygapControllerGetUniqueFieldValues(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaygapApi.paygapControllerGetUniqueFieldValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Import personnel data
         * @param {ImportPaygapPersonnelDto} importPaygapPersonnelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paygapControllerImportPersonnel(importPaygapPersonnelDto: ImportPaygapPersonnelDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paygapControllerImportPersonnel(importPaygapPersonnelDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaygapApi.paygapControllerImportPersonnel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Triggers PayGap analysis via Azure Logic Apps. This is a fire-and-forget operation - results will be stored in the database when the analysis completes.
         * @summary Run PayGap analysis
         * @param {string} authorization 
         * @param {RunAnalysisRequestDto} runAnalysisRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paygapControllerRunAnalysis(authorization: string, runAnalysisRequestDto: RunAnalysisRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunAnalysisResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paygapControllerRunAnalysis(authorization, runAnalysisRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaygapApi.paygapControllerRunAnalysis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update PayGap settings for current company
         * @param {UpdatePaygapSettingsDto} updatePaygapSettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paygapControllerUpdateSettings(updatePaygapSettingsDto: UpdatePaygapSettingsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaygapSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paygapControllerUpdateSettings(updatePaygapSettingsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaygapApi.paygapControllerUpdateSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaygapApi - factory interface
 * @export
 */
export const PaygapApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaygapApiFp(configuration)
    return {
        /**
         * Proxies request to Azure Logic Apps grade estimator API. Returns suggested grades based on trait values and job/seniority points.
         * @summary Run grade estimation AI
         * @param {string} authorization 
         * @param {GradeEstimatorRequestDto} gradeEstimatorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paygapControllerEstimateGrades(authorization: string, gradeEstimatorRequestDto: GradeEstimatorRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<GradeEstimatorResponseDto>> {
            return localVarFp.paygapControllerEstimateGrades(authorization, gradeEstimatorRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get paygap metrics for current company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paygapControllerGetCurrentCompanyPaygapMetrics(options?: RawAxiosRequestConfig): AxiosPromise<Array<PaygapMetricItemDto>> {
            return localVarFp.paygapControllerGetCurrentCompanyPaygapMetrics(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get personnel data for current company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paygapControllerGetCurrentCompanyPersonnel(options?: RawAxiosRequestConfig): AxiosPromise<Array<PaygapPersonnelDto>> {
            return localVarFp.paygapControllerGetCurrentCompanyPersonnel(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get PayGap settings for current company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paygapControllerGetSettings(options?: RawAxiosRequestConfig): AxiosPromise<PaygapSettingsDto> {
            return localVarFp.paygapControllerGetSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * Extracts unique values for education, positions, and grading fields from personnel data. Used for auto-populating analysis parameters.
         * @summary Get unique field values from personnel data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paygapControllerGetUniqueFieldValues(options?: RawAxiosRequestConfig): AxiosPromise<UniqueFieldValuesDto> {
            return localVarFp.paygapControllerGetUniqueFieldValues(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import personnel data
         * @param {ImportPaygapPersonnelDto} importPaygapPersonnelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paygapControllerImportPersonnel(importPaygapPersonnelDto: ImportPaygapPersonnelDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.paygapControllerImportPersonnel(importPaygapPersonnelDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Triggers PayGap analysis via Azure Logic Apps. This is a fire-and-forget operation - results will be stored in the database when the analysis completes.
         * @summary Run PayGap analysis
         * @param {string} authorization 
         * @param {RunAnalysisRequestDto} runAnalysisRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paygapControllerRunAnalysis(authorization: string, runAnalysisRequestDto: RunAnalysisRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RunAnalysisResponseDto> {
            return localVarFp.paygapControllerRunAnalysis(authorization, runAnalysisRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update PayGap settings for current company
         * @param {UpdatePaygapSettingsDto} updatePaygapSettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paygapControllerUpdateSettings(updatePaygapSettingsDto: UpdatePaygapSettingsDto, options?: RawAxiosRequestConfig): AxiosPromise<PaygapSettingsDto> {
            return localVarFp.paygapControllerUpdateSettings(updatePaygapSettingsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaygapApi - object-oriented interface
 * @export
 * @class PaygapApi
 * @extends {BaseAPI}
 */
export class PaygapApi extends BaseAPI {
    /**
     * Proxies request to Azure Logic Apps grade estimator API. Returns suggested grades based on trait values and job/seniority points.
     * @summary Run grade estimation AI
     * @param {string} authorization 
     * @param {GradeEstimatorRequestDto} gradeEstimatorRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaygapApi
     */
    public paygapControllerEstimateGrades(authorization: string, gradeEstimatorRequestDto: GradeEstimatorRequestDto, options?: RawAxiosRequestConfig) {
        return PaygapApiFp(this.configuration).paygapControllerEstimateGrades(authorization, gradeEstimatorRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get paygap metrics for current company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaygapApi
     */
    public paygapControllerGetCurrentCompanyPaygapMetrics(options?: RawAxiosRequestConfig) {
        return PaygapApiFp(this.configuration).paygapControllerGetCurrentCompanyPaygapMetrics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get personnel data for current company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaygapApi
     */
    public paygapControllerGetCurrentCompanyPersonnel(options?: RawAxiosRequestConfig) {
        return PaygapApiFp(this.configuration).paygapControllerGetCurrentCompanyPersonnel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get PayGap settings for current company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaygapApi
     */
    public paygapControllerGetSettings(options?: RawAxiosRequestConfig) {
        return PaygapApiFp(this.configuration).paygapControllerGetSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Extracts unique values for education, positions, and grading fields from personnel data. Used for auto-populating analysis parameters.
     * @summary Get unique field values from personnel data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaygapApi
     */
    public paygapControllerGetUniqueFieldValues(options?: RawAxiosRequestConfig) {
        return PaygapApiFp(this.configuration).paygapControllerGetUniqueFieldValues(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import personnel data
     * @param {ImportPaygapPersonnelDto} importPaygapPersonnelDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaygapApi
     */
    public paygapControllerImportPersonnel(importPaygapPersonnelDto: ImportPaygapPersonnelDto, options?: RawAxiosRequestConfig) {
        return PaygapApiFp(this.configuration).paygapControllerImportPersonnel(importPaygapPersonnelDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Triggers PayGap analysis via Azure Logic Apps. This is a fire-and-forget operation - results will be stored in the database when the analysis completes.
     * @summary Run PayGap analysis
     * @param {string} authorization 
     * @param {RunAnalysisRequestDto} runAnalysisRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaygapApi
     */
    public paygapControllerRunAnalysis(authorization: string, runAnalysisRequestDto: RunAnalysisRequestDto, options?: RawAxiosRequestConfig) {
        return PaygapApiFp(this.configuration).paygapControllerRunAnalysis(authorization, runAnalysisRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update PayGap settings for current company
     * @param {UpdatePaygapSettingsDto} updatePaygapSettingsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaygapApi
     */
    public paygapControllerUpdateSettings(updatePaygapSettingsDto: UpdatePaygapSettingsDto, options?: RawAxiosRequestConfig) {
        return PaygapApiFp(this.configuration).paygapControllerUpdateSettings(updatePaygapSettingsDto, options).then((request) => request(this.axios, this.basePath));
    }
}

